import { render, staticRenderFns } from "./account-register.vue?vue&type=template&id=3408bf96&scoped=true&"
import script from "./account-register.vue?vue&type=script&lang=js&"
export * from "./account-register.vue?vue&type=script&lang=js&"
import style0 from "./account-register.vue?vue&type=style&index=0&id=3408bf96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408bf96",
  null
  
)

export default component.exports